import * as Yup from 'yup';

const phoneRegEx = /^\(?[2-9]\d{2}\)?-?\d{3}-?\d{4}$/;
export const yupPhoneValidator = () =>
  Yup.string().matches(phoneRegEx, {
    message: 'Phone number is not valid, expecting XXX-XXX-XXXX',
    excludeEmptyString: true,
  });

const zipCodeShortRegEx = /^\d{5}$/;
/**
 * Validate a short 5 digit ZIP
 */
export const yupZipShortValidator = () =>
  Yup.string().matches(zipCodeShortRegEx, {
    message: 'Zip code is not valid, expecting 5 digits',
    excludeEmptyString: true,
  });

const zipCodeRegEx = /^\d{5}((-|\+)\d{4})?$/;
/**
 * Validate a ZIP that is either 5 digits or the full 5+4
 */
export const yupZipValidator = () =>
  Yup.string().matches(zipCodeRegEx, {
    message: 'Zip code is not valid, expecting 5 or 9 digits',
    excludeEmptyString: true,
  });

const einRegEx = /^\d{2}-?\d{7}$/;
export const yupEinValidator = () =>
  Yup.string().matches(einRegEx, {
    message: 'EIN is not valid, expecting XX-XXXXXXX',
    excludeEmptyString: true,
  });

const npnRegEx = /^[0-9]{5,10}$/;
export const yupNpnValidator = () =>
  Yup.string().matches(npnRegEx, {
    message: 'NPN is not valid, expecting 5 to 10 digits',
    excludeEmptyString: true,
  });

const stringNumberRegEx = /^\d*$/;
/**
 * Validate that a string only contains digits
 */
export const yupStringNumberValidator = () =>
  Yup.string().matches(stringNumberRegEx, {
    message: 'Invalid value, expecting only numeric digits',
    excludeEmptyString: true,
  });

/**
 * Validate that the date is in MM/DD/YYYY format
 * and its a real date
 */
export const yupLongDateValidator = () =>
  Yup.date()
    .required('Required')
    .transform((value: Date, original: string) => {
      // Validate the format, change to bad type if not
      return /^\d\d\/\d\d\/\d\d\d\d$/.test(original) ? value : false;
    })
    .transform((value: Date | false, original: string) => {
      // Validate the date is real, unlike Feb 30th, change to bad type if not
      if (
        value &&
        value.getUTCMonth() + 1 === parseInt(original.substring(0, 2))
      ) {
        return value;
      }
      return false;
    })
    .typeError('Must be a valid date in MM/DD/YYYY format');
